import React from "react";
import { useHistory } from "react-router-dom";

import { getAutomationDataAttr } from "@/utils/automationUtils";

import CardIcon from "./icon--card.svg?component";
import { ReminderBanner } from "./ReminderBanner";

export function PaywallReminder() {
  const history = useHistory();
  const onPress = () => history.push("/app/patient-payment");

  return (
    <ReminderBanner
      cta="Add Card"
      Icon={<CardIcon />}
      onPress={onPress}
      {...getAutomationDataAttr("patient-home-payment-reminder")}
    >
      Reminder: A payment method must be kept on file to continue using aptihealth.
    </ReminderBanner>
  );
}
